module.exports = __webpack_public_path__ + "img/吐.a936eab2.gif";